import styled from "styled-components";
import { EModalTitle } from "@/interface/enum";

import bg1 from '@/images/modal-bg1.png'
import bg2 from '@/images/modal-bg2.png'
import bg3 from '@/images/modal-bg3.png'
import close from '@/images/modal-close.png'
import title1 from '@/images/modal-title1.png'
import title2 from '@/images/modal-title2.png'
import title3 from '@/images/modal-title3.png'
import title4 from '@/images/modal-title4.png'
import title5 from '@/images/modal-title5.png'
import title6 from '@/images/modal-title6.png'

import awardBorder from '@/images/modal-award-bg.png';

const Container = styled.div.attrs((props) => ({
  modalType: props.modalType,
  titleType: props.titleType,// [充值区服,领取记录,提示,恭喜获得,更换游戏,赠送记录]

  titleImg: [title1, title2, title3, title4, title5, title6][props.titleType],
  titleWidth: [107, 108, 64, 108, 311, 108][props.titleType],
  bgImg: [bg2, bg2, bg2, bg1, bg3, bg2][props.modalType],
  width: [459, 459, 459, 857, 459, 459][props.modalType],
  height: [392, 392, 392, 615, 392, 392][props.modalType]
}))`
  position: relative;
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  background-image: url(${props => props.bgImg});
  padding-top: 40px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;

  .closeIcon {
    cursor: pointer;
    width: 52px;
    height: 55px;
    position: absolute;
    right: 30px;
    top: 20px;
    background-image: url(${close});
  }

  .title {
    width: ${props => props.titleWidth}px;
    height: 34px;
    background-image: url(${props => props.titleImg});
    position: relative;
    left: 50%;
    top: -20px;
    transform: translateX(-50%);
    transition: all 3s;
  }

  .disTable {
    display: table;
    width: 100%;
    height: ${props => props.height - 169 - 50}px;
    text-align: center;

    .disTableCell {
      display: table-cell;
      vertical-align: middle;
      font-size: 20px;
      color: #0070b0;
      font-weight: bold;
      line-height: 30px;
    }
  }
`;

const AwardBox = styled.div`
  background-image: url(${awardBorder});
  background-repeat: no-repeat;
  width: 119px;
  height: 111px;
  padding-top: 110px;
  margin: 60px auto 50px;
  position: relative;

  .awardIntegral {
    width: 115px;
    height: 32px;
    position: absolute;
    left: 57px;
    top: -25px;
    transform: translate(-50%, -50%);
  }

  .awardImg {
    max-width: 100px;
    max-height: 100px;
    min-height: 55px;
    min-width: 55px;
    position: absolute;
    left: 57px;
    top: 57px;
    transform: translate(-50%, -50%);
  }

  p {
    margin: 10px -50px 0;
    font-size: 20px;
    line-height: 28px;
    color: #0070b0;
    font-weight: bold;
  }
`;

const AwardIntegralBox = styled.div`
  margin: 115px auto 50px;
  position: relative;

  .awardIntegral {
    width: 115px;
    height: 32px;
    position: absolute;
    left: 212px;
    top: -25px;
    transform: translate(-50%, -50%);
  }

  p {
    margin: 10px -50px 0;
    font-size: 20px;
    line-height: 28px;
    color: #0070b0;
    font-weight: bold;
  }
`;

const GameItem = styled.div`
  width: 180px;
  height: 155px;
  box-sizing: border-box;
  border: 3px solid #fcc755;
  display: inline-block;
  margin: 0 20px;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &:hover:before,
  &.active:before {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  img {
    width: 100%;
    height: 100%;
  }

  p {
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 24px;
    line-height: 24px;
    width: 100%;
    color: #852b03;
    font-size: 14px;
    background-color: rgba(0, 0, 0, 0.6);
    font-weight: initial;
  }
`;

const Recharge = styled.div`
  color: #881300;
  position: relative;
  height: calc(100% - 65px);
  margin: 0 40px;
  padding-top: 50px;

  .content {
    height: calc(100% - 160px);

    ul {
      text-align: left;
      min-height: 280px;

      li {
        display: inline-block;
        height: 50px;
        min-width: 150px;
        padding: 0 25px;
        font-size: 16px;
        line-height: 50px;
        text-align: center;
        margin-right: 25px;
        margin-bottom: 25px;
        background-color: #ffffff;
        border: 1px solid #004688;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;

        span {
          color: #204d9c;
          font-weight: 600;
          margin-bottom: 20px;

          &.server {
            font-size: 14px;
          }
        }
      }
    }

    div.loading {
      font-size: 18px;
      position: absolute;
      left: 50%;
      top: 30%;
      transform: translateX(-50%);
      color: #204d9c;
    }

    .page {
      font-size: 16px;

      span {
        display: inline-block;
        margin: 0 25px;
        cursor: pointer;
        text-decoration: underline;
        user-select: none;
        color: #204d9c;
      }
    }
  }

  .tip {
    position: absolute;
    bottom: 0;
    left: 0;
    display: table;
    width: 100%;
    height: 160px;
    text-align: center;

    & > div {
      display: table-cell;
      vertical-align: middle;

      p {
        text-align: left;
        font-size: 14px;
        line-height: 26px;
        color: #204d9c;
      }
    }
  }
`;

const PackagePage = styled.div`

  ul {
    margin: 20px 40px 0;
    min-height: 180px;
    position: relative;

    & > li {
      overflow: hidden;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 0;
      color: #2172a5;
      margin-bottom: 5px;

      &:first-child {
        font-size: 15px;
        font-weight: bold;
        border-bottom: 1px dashed #6ab2d6;
        color: #204d9c;
        margin-bottom: 10px;
        line-height: 32px;
        padding: 0;
      }

      &.none {
        position: absolute;
        left: 50%;
        top: 60%;
        transform: translate(-50%, -50%);
      }

      & > div {
        float: left;
        display: inline-block;

        &:nth-child(1) {
          width: 35%;
        }

        &:nth-child(2) {
          width: 25%;
        }

        &:nth-child(3) {
          width: 40%;
          word-break: break-all;
          white-space: normal;

          input {
            display: inline-block;
            border: none;
            border-radius: 5px;
            width: 70px;
            padding: 2px 2px;
            font-size: 12px;
          }

          span {
            display: inline-block;
            text-decoration: underline;
            margin-left: 3px;
            cursor: pointer;
          }
        }
      }
    }
  }

  & > button {
    cursor: pointer;

    &:hover {
      color: #204d9c;
    }
  }

  & > button, & > span {
    font-size: 14px;
    display: inline-block;
    border: none;
    color: #204d9c;
    background-color: transparent;
    margin: 15px 12px 0;
  }
`

export {
  Container,
  AwardBox,
  AwardIntegralBox,
  GameItem,
  Recharge,
  PackagePage
}
